import { useState } from "react";
import Address from "typedef/Address";
import CButton from "components/CButton";
import { useNavigate } from "react-router-dom";
import color from "context/MaterialUITheme/color";
import { Box, Container, List, ListItem, Typography } from "@mui/material";
import CAddressAutocomplete from "components/CAddressAutocomplete";

export default function CHow() {
  const navigate = useNavigate();
  const [address, setAddress] = useState<Address | null>(null);

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{ backgroundColor: color.purple }}
    >
      <Container maxWidth="lg">
        <Box p={{ md: 8, xs: 0 }} py={{ md: 8, xs: 4 }} color={color.white}>
          <Typography
            variant="h3"
            mb={{ md: 3, xs: 0 }}
            fontSize={{ xs: "2rem", md: "3rem" }}
          >
            How does it work?
          </Typography>
          <List sx={{ fontSize: { xs: "1rem", md: "1.4rem" } }}>
            <ListItem disableGutters alignItems="flex-start">
              <Box
                mr={1}
                mt={0.4}
                display="inline"
                fontFamily="Pro Display Semibold"
              >
                1.
              </Box>
              <Typography sx={{ fontSize: { xs: "1rem", md: "1.4rem" } }}>
                <span style={{ fontFamily: "Pro Display Semibold" }}>
                  Apply
                </span>{" "}
                - Complete a 1-minute application to get an instant
                pre-qualification.
              </Typography>
            </ListItem>
            <ListItem disableGutters alignItems="flex-start">
              <Box
                mr={1}
                mt={0.4}
                display="inline"
                fontFamily="Pro Display Semibold"
              >
                2.
              </Box>
              <Typography sx={{ fontSize: { xs: "1rem", md: "1.4rem" } }}>
                <span style={{ fontFamily: "Pro Display Semibold" }}>
                  Choose
                </span>{" "}
                - Choose between a HELOC (Line of Credit) and HELOAN (fully
                funded loan).
              </Typography>
            </ListItem>
            <ListItem disableGutters alignItems="flex-start">
              <Box
                mr={1}
                mt={0.4}
                display="inline"
                fontFamily="Pro Display Semibold"
              >
                3.
              </Box>
              <Typography sx={{ fontSize: { xs: "1rem", md: "1.4rem" } }}>
                <span style={{ fontFamily: "Pro Display Semibold" }}>
                  Close
                </span>{" "}
                - Schedule your online notary closing, and then we fund 3 days
                later.*
              </Typography>
            </ListItem>
          </List>
          <CAddressAutocomplete
            sx={{ paddingBottom: { sm: "1rem" }, mt: 1 }}
            address={address}
            placeholder="Start typing your home address and please select from the dropdown."
            setAddress={setAddress}
            noLabel
            InputProps={{
              endAdornment: (
                <CButton
                  variant="contained"
                  onClick={() => navigate("/signup", { state: address })}
                  sx={{
                    p: 1,
                    px: 3,
                    width: "15rem",
                    fontSize: "1rem",
                    display: { xs: "none", sm: "block", md: "block" },
                  }}
                >
                  Check My Rate
                </CButton>
              ),
            }}
          />
          <Box mt={2} display={{ xs: "block", sm: "none", md: "none" }}>
            <CButton
              fullWidth
              variant="outlined"
              onClick={() => navigate("/signup", { state: address })}
            >
              Check My Rate
            </CButton>
          </Box>
        </Box>
      </Container>
    </Container>
  );
}
